import { Form } from 'react-bootstrap';
import { Controller, FieldValues, UseControllerProps } from 'react-hook-form';
import { useId } from 'react';

type FormInputProps<TFieldValues extends FieldValues = FieldValues> = Omit<
  UseControllerProps<TFieldValues>,
  'control'
> &
  Required<Pick<UseControllerProps<TFieldValues>, 'control'>> & {
    label?: string | React.ReactNode;
    type?: string;
    as?: React.ElementType;
    style?: React.CSSProperties;
    readonly?: boolean;
    placeholder?: string;
  };

export const FormInput = <TFieldValues extends FieldValues = FieldValues>({
  label = undefined,
  type = undefined,
  as = undefined,
  style = undefined,
  readonly = false,
  placeholder = undefined,
  ...props
}: FormInputProps<TFieldValues>) => {
  // ユニークなIDを生成（React 18以降）
  const inputId = useId();

  return (
    <Form.Group className="mb-3">
      {label && <Form.Label htmlFor={inputId}>{label}</Form.Label>}
      <Controller
        {...props}
        render={({ field, fieldState }) => (
          <>
            <Form.Control
              id={inputId}
              type={type}
              {...field}
              isInvalid={!!fieldState.error}
              as={as}
              style={style}
              readOnly={readonly}
              placeholder={placeholder}
            />
            <Form.Control.Feedback type="invalid">
              {fieldState.error?.message}
            </Form.Control.Feedback>
          </>
        )}
      />
    </Form.Group>
  );
};
